export default {"src":"/_next/static/media/GovSmart_Icon_Simple.1e36b896.svg","height":230,"width":363,"blurWidth":0,"blurHeight":0};